module.exports = __webpack_public_path__ + "static/img/slide_small3.c43d8ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slide_small3.png
// module id = 82mf
// module chunks = 5